export { default as useForeignEquivalentPage } from './useForeignEquivalentPage';
